import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

function formRoot({ className, ...rest }: ComponentProps<'div'>) {
  return (
    <div
      className={twMerge(
        'flex grow flex-col bg-monochromatic-200',
        className,
      )}
      {...rest}
    />
  )
}

function formHeader({ className, ...rest }: ComponentProps<'div'>) {
  return (
    <div
      className={twMerge(
        'sticky top-20 z-20 w-full bg-monochromatic-200 shadow-nav xl:top-24 2xl:top-28',
        className,
      )}
      {...rest}
    />
  )
}

function formHeaderContent({ className, ...rest }: ComponentProps<'div'>) {
  return (
    <div
      className={twMerge(
        'mx-auto flex flex-wrap items-center justify-center gap-5 px-10 py-4 lg:justify-between lg:px-40 xl:px-80 2xl:w-1/2 2xl:px-0',
        className,
      )}
      {...rest}
    />
  )
}

function formHeaderTitle({ className, ...rest }: ComponentProps<'h1'>) {
  return (
    <h1
      className={twMerge('text-2xl font-bold text-bios-secondary', className)}
      {...rest}
    />
  )
}

function formContent({ className, ...rest }: ComponentProps<'main'>) {
  return (
    <main
      className={twMerge(
        'mx-auto w-full p-10 lg:px-40 xl:px-80 2xl:w-1/2 2xl:px-0',
        className,
      )}
      {...rest}
    />
  )
}

function formContentMain({ className, ...rest }: ComponentProps<'form'>) {
  return (
    <form className={twMerge('flex flex-col gap-10', className)} {...rest} />
  )
}

export const Form = {
  Root: formRoot,
  HeaderRoot: formHeader,
  HeaderTitle: formHeaderTitle,
  HeaderContent: formHeaderContent,
  Content: formContent,
  ContentMain: formContentMain,
}
